import { render, staticRenderFns } from "./bahan.vue?vue&type=template&id=510aa8de"
import script from "./bahan.vue?vue&type=script&lang=js"
export * from "./bahan.vue?vue&type=script&lang=js"
import style0 from "./bahan.vue?vue&type=style&index=0&id=510aa8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports